import { createSlice } from "@reduxjs/toolkit";
import { showAnnouncement } from "../actions";

const initialState = {
  announcement: [],
};

const announcementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {},
  extraReducers: {
    [showAnnouncement.fulfilled]: (state, action) => {
      state.announcement = action.payload || [];
    },
  },
});

export const responseAnnouncement = (state) => state.announcement;

export default announcementSlice.reducer;
